<template>
  <material-card
        :title="$t('globals.terms_conditions').toUpperCase()"
        :color="$vuetify.theme.themes.light.secondary"
        icon="rule"
      >
        <v-card-text>
          <p v-html="terms">
            </p>
        </v-card-text>
      </material-card>
</template>

<script>
  export default {
	name: "terms-conditions",
    data: () => ({
      terms: `<html>

<head>
<meta http-equiv=Content-Type content="text/html; charset=utf-8">
<meta name=Generator content="Microsoft Word 15 (filtered)">
<style>
<!--
 /* Font Definitions */
 @font-face
	{font-family:"Cambria Math";
	panose-1:2 4 5 3 5 4 6 3 2 4;}
@font-face
	{font-family:Calibri;
	panose-1:2 15 5 2 2 2 4 3 2 4;}
 /* Style Definitions */
 p.MsoNormal, li.MsoNormal, div.MsoNormal
	{margin-top:0in;
	margin-right:0in;
	margin-bottom:8.0pt;
	margin-left:0in;
	line-height:107%;
	font-size:11.0pt;
	font-family:"Calibri",sans-serif;}
p
	{margin-right:0in;
	margin-left:0in;
	font-size:12.0pt;
	font-family:"Times New Roman",serif;}
.MsoChpDefault
	{font-family:"Calibri",sans-serif;}
.MsoPapDefault
	{margin-bottom:8.0pt;
	line-height:107%;}
@page WordSection1
	{size:8.5in 11.0in;
	margin:1.0in 1.0in 1.0in 1.0in;}
div.WordSection1
	{page:WordSection1;}
 /* List Definitions */
 ol
	{margin-bottom:0in;}
ul
	{margin-bottom:0in;}
-->
</style>

</head>

<body lang=EN-US link=blue vlink="#954F72" style='word-wrap:break-word'>

<div class=WordSection1>

<p class=MsoNormal style='line-height:normal'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>Prudent Benefits Administration
Services Inc., Benchmark Decisions Ltd., and Student Benefits Administrators
Inc. (hereinafter referred to collectively as “PBAS”, for ease of reference), would
like to express its thanks to all those who visit this Website. However, please
be aware of the following terms and conditions of using this Site. If you do
not agree with them, please exit this Site. Each time you use this Site you
indicate your acceptance of the terms and conditions set out under &quot;Terms &amp;
Conditions&quot;.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:0in'><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>In
registering for access to this Site, users agree that:</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>You have authorization from your employer or from PBAS to be
registered as a user.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>You will keep your username and password strictly confidential
and not disclose your username and password to any other person or entity.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>You will be responsible for all uses of your username and
password and all actions performed using your username and password, including
unauthorized uses and actions performed without your consent.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>4.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>You will notify PBAS immediately of the loss or unauthorized use
of your username and password.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>5.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>PBAS shall not be responsible for confirming your identity prior
to your accessing the Site.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>6.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>You will use this Site only for the purpose of (i) administering
and/or managing the Benefit plan(s) to which you have been granted access; (ii)
obtaining health and wellness information; and (iii) accessing such counselling
and other services as may be provided on or through the Site; as applicable,
and for no other or improper purpose.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>7.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>If you are a Plan Administrator or Advisor, any personal
information obtained from this Site or through any third-party website to which
you are provided access through this Site will be adequately safeguarded by you
in accordance with privacy legislation applicable where you carry on business.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>8.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>Regardless of whether you are a Plan Administrator or Advisor
you are bound by (i) the confidentiality and/or privacy provisions contained in
any applicable agreement, policy or other document governing your relationship
with PBAS, or its affiliates, with respect to the content of this Site, any
third party website to which you are provided access by PBAS through this Site;
and (ii) the terms and conditions set out under &quot;Terms &amp;
Conditions&quot;.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>9.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>You are responsible for the accuracy and completeness of the
information that you submit through the Site. To the extent that the Site
permits you access to online message/discussion boards where you may submit my
contributions for others to read, none of my contributions shall contain
anything unlawful and/or obscene.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>10.<span style='font:7.0pt "Times New Roman"'>&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>PBAS, and its contracted third-party service providers, as
applicable, have the right to monitor your use of this Site, and any
third-party website to which you are granted access through this Site, and
review information created or accessed under your username and password.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>11.<span style='font:7.0pt "Times New Roman"'>&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>PBAS has the right to restrict or cancel your access to any part
or parts of this Site, or to any part or parts of a website that PBAS may provide
you with access to through this Site, at any time, with or without notice.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>12.<span style='font:7.0pt "Times New Roman"'>&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>Your use of this Site is subject to the terms and conditions set
out in here, and any other terms and conditions that PBAS may communicate to
you. You agree to comply with such terms and conditions.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>13.<span style='font:7.0pt "Times New Roman"'>&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>If your association with your employer and/or PBAS terminates,
you agree to immediately discontinue use of your username and password.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>14.<span style='font:7.0pt "Times New Roman"'>&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>Your obligations under this Agreement continue even after you
stop using this Site or you relationship with your employer or with PBAS ends.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>15.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>Your
violation of the provisions of these Terms &amp; Conditions could result in:
(a) termination of your use of this Site; (b) notification of the violation to
your employer; and (c) liability for damages for the misuse of information
provided to you through this Site or for misuse of the Site itself.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>16.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>The
contents of this Site, including the manner in which the contents are
displayed, are the sole property of PBAS or of its licensors. Except as set out
below, you are not granted any rights in or to the contents made available on
or via the Site or in or to the Site itself. All such rights remain with, and
are reserved by, PBAS or their respective owners.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>17.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>PBAS
grants you a limited license to: (i) display the contents of this Site on your
computer, or other electronic device used to access this Site; and (ii) print,
download and use the contents on this Site solely for informational purposes;
provided that the Site contents are not modified in any way and that all existing
copyright and other notices are displayed. You agree not to, or allow others
to, directly or indirectly, attempt to or actually disrupt, impair or interfere
with, alter or modify this Site or any of its contents.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>18.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>PBAS
expressly disclaims all representations, warranties or conditions, express or
implied, statutory or otherwise, including, without limitation, the warranties
and conditions of merchantable quality and fitness for a particular purpose,
non-infringement, compatibility, timeliness, security or accuracy, and any
representations, warranties or conditions that may arise from a course of
dealing or usage of trade.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>19.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>All
information provided on this Site, including these Terms &amp; Conditions, is
subject to change without notice. You should, therefore, review this &quot;Terms
&amp; Conditions&quot; page each time you visit this Site to inform yourself of
any changes. If you do not agree with any changes, please exit this Site. Your
continued use of this Website after PBAS has made any changes to this &quot;Terms
&amp; Conditions&quot; page is deemed to constitute your acceptance of such
changes.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>20.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>This Site
does not, and is not intended to provide any legal, financial, accounting,
insurance or tax advice and should not be relied upon by you for such advice.
You should secure advice from your own professional advisors. </span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>21.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>Your use
of this Site is entirely at your own risk. Neither PBAS, nor any of its
affiliated companies, nor their officers, directors, employees or agents, nor
any other person associated with the creation and/or maintenance of this Site
or its contents shall be responsible to any person for any harm, loss or damage
(including any loss of data or damage to your computer system), however caused,
that may arise from your use of the Site or its contents, or the unavailability
of the Site for your use, including, without limitation, any direct, indirect,
special, third party, or consequential damages, even if it or they have been
advised of the possibility of such harm, loss or damage. Without limiting the
foregoing, PBAS shall not be responsible for any detrimental reliance that you
may place upon this Site, or its contents. By accessing and using this Site,
you assume the risk that the information and documentation presented may not
meet your needs and requirements and that, particularly in the medical and
health/wellness areas of websites provided by PBAS and accessed through this
Site, such information and documentation may be offensive to some.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>22.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>If PBAS
provides you with any user name and password to access any secure area of this
Site, you agree to keep such user name and password strictly confidential and
not to disclose the user name and password to any other person or entity. </span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>23.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>You agree
to be liable for all uses of your user name and password, including unauthorized
use without your consent, and you acknowledge that PBAS shall not be
responsible for confirming the identity of any user. You agree to notify PBAS
immediately of the loss or unauthorized use of your user name and password.
PBAS has the right to restrict or cancel your access to any part or parts of
this Site, including any website made accessible to you through this Site,
where access is controlled by login information and/or passwords provided by
PBAS at any time, with or without notice.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>24.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>The
limitations expressed above shall apply to your use of this Site regardless of
the causes or circumstances giving rise to the claim, even if such claim is
based on breach of contract, negligence or other tort, and shall survive a
fundamental breach or failure of essential purpose of any limited remedy or
these terms and conditions. You acknowledge and agree that any claim or cause
of action you may have arising out of, or relating to, the Site must be filed
within one (1) year after such claim or cause of action arises, or it will be
permanently barred.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>25.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>PBAS, its
affiliates and its contracted service providers for the Site, or for websites
accessible through the Site, may use &quot;cookies&quot; to facilitate your
online experience or to provide you with access to the Site. A &quot;cookie&quot;
is a text file that is placed on your hard disk by a web page server. Cookies
cannot be used to run programs or to deliver viruses to your computer. Cookies
are uniquely assigned to you, and can only be read by a web server in the
domain that issued the cookie to you. One of the primary purposes of cookies is
to ensure that you are authorized to use this Site. Encrypted cookies, which
contain your insurance policy and certificate number, may be used for the
purposes of authenticating your identity and providing you with access to this
Site, or to any other website provided by PBAS through this Site. Your ability
to access this Site, or any other website provided through this Site, may be
limited should your computer not accept these encrypted cookies.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>26.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>All
information provided on this Site is used for the business purposes of PBAS.
You agree that the Internet is not a secure medium, privacy cannot be ensured
and security and/or confidentiality over the Internet are not guaranteed.
Without limiting any other disclaimer contained under &quot;Terms &amp;
Conditions&quot; and “Privacy Policy”, PBAS, shall not be responsible for any
loss or damages you may incur as a result of your communicating confidential
and/or personal information to us over the Internet or of our communicating, at
your request, confidential and/or personal information to you over the
Internet. Please read our Privacy Policy for information about our privacy
practices.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>27.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>Certain
information on this Site relating to segregated funds and underlying mutual
funds may be provided by third parties. Without limiting any other disclaimer
contained under &quot;Terms &amp; Conditions&quot;, PBAS will not be
responsible for any errors in this information, or for any loss or damages to
any person caused by reliance on this information.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>28.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>You agree
that you will not use, or permit anyone else to use, any robot, scraper, spider
or other automated devices or means to access or use the Site for any purpose
without the prior expressed written consent of PBAS. You agree that you will
not: (i) interfere or attempt to interfere with the proper working of the Site;
(ii) bypass any measures used to prevent or restrict access to the Site; or
(iii) take any action that imposes an unreasonable or disproportionately large
load on the infrastructure used to run and maintain the Site.</span></p>

</div>

</body>

</html>
`,
    })
  }
</script>